import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiTarget, FiArrowRight, FiArrowLeft} = FiIcons;

const Step1 = ({ formData, updateFormData, onNext, onPrev }) => {
  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });
  };

  const canProceed = formData.bookMessage && formData.bookReader && formData.bookTransformation;

  return (
    <div className="max-w-3xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white rounded-2xl shadow-xl p-8"
      >
        <div className="text-center mb-8">
          <div className="bg-gradient-to-r from-blue-600 to-orange-500 p-3 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <SafeIcon icon={FiTarget} className="text-2xl text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            Step 1: Define Your Book's Mission & Reader
          </h2>
          <p className="text-gray-600">
            Before you market your book, you need to define why you wrote it and who you wrote it for.
          </p>
        </div>

        <div className="space-y-6">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
          >
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              What is your book's core message?
            </label>
            <textarea
              value={formData.bookMessage}
              onChange={(e) => handleInputChange('bookMessage', e.target.value)}
              placeholder="Share the heart of what your book is about..."
              className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none h-24 text-gray-700"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3 }}
          >
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              Who is your book for? (Be specific!)
            </label>
            <textarea
              value={formData.bookReader}
              onChange={(e) => handleInputChange('bookReader', e.target.value)}
              placeholder="Describe your ideal reader - their struggles, desires, and characteristics..."
              className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none h-24 text-gray-700"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4 }}
          >
            <label className="block text-lg font-semibold text-gray-700 mb-3">
              What transformation does your book offer?
            </label>
            <textarea
              value={formData.bookTransformation}
              onChange={(e) => handleInputChange('bookTransformation', e.target.value)}
              placeholder="How will readers be different after reading your book?"
              className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none h-24 text-gray-700"
            />
          </motion.div>
        </div>

        <div className="flex justify-between mt-8">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onPrev}
            className="bg-gray-500 text-white px-6 py-3 rounded-xl font-semibold flex items-center hover:bg-gray-600 transition-colors"
          >
            <SafeIcon icon={FiArrowLeft} className="mr-2" />
            Back
          </motion.button>

          <motion.button
            whileHover={{ scale: canProceed ? 1.05 : 1 }}
            whileTap={{ scale: canProceed ? 0.95 : 1 }}
            onClick={onNext}
            disabled={!canProceed}
            className={`px-6 py-3 rounded-xl font-semibold flex items-center transition-all ${
              canProceed
                ? 'bg-gradient-to-r from-blue-600 to-orange-500 text-white hover:shadow-lg'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Continue
            <SafeIcon icon={FiArrowRight} className="ml-2" />
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default Step1;